import { Injectable } from '@angular/core';

/**
 * HelperService
 */
@Injectable({ providedIn: 'root' })
export class HelperService {
  /**
   * Covert array of objects to flat object,
   * using the given key as accessor key on the flatted object.
   *
   * @param arr any[]
   * @param key string
   * @return Object
   */
  static normalize(arr: any[], key: string): any {
    return Object.assign({}, ...arr.map(item => ({ [item[key]]: item })));
  }
}
